import { Loop } from "@mui/icons-material";
import { Card, CircularProgress, IconButton, Tooltip } from "@mui/material";
import { StyledCard } from "../../styled/card";

const CardDashboard = ({
  component: ComponentDashboard,
  text,
  fetchData,
  isFetching,
  didInvalidate,
}) => {
  return (
    <StyledCard.CardContainer item xs={12} md={6} lg={4} xl={3}>
      <Card
        sx={{
          borderRadius: "6px",
          flex: 1,
          boxShadow: "1px 1px 4px #808080e0",
        }}>
        <StyledCard.IconRefreshContainer didInvalidate={didInvalidate}>
          {didInvalidate && (
            <Tooltip title="Error en la consulta">
              <StyledCard.ErrorDiv />
            </Tooltip>
          )}

          {isFetching ? (
            <StyledCard.LoadingContainer>
              <CircularProgress size={21} />
            </StyledCard.LoadingContainer>
          ) : (
            <IconButton
              sx={{
                padding: 3,
              }}
              onClick={fetchData}>
              <Loop
                sx={{
                  cursor: "pointer",
                  color: "#818181",
                  "&:hover, &:focus": {
                    color: "#145a8c",
                  },
                  "&:active": {
                    color: "#2c148c",
                  },
                }}
              />
            </IconButton>
          )}
        </StyledCard.IconRefreshContainer>
        <StyledCard.Dashboard>{ComponentDashboard}</StyledCard.Dashboard>
        <StyledCard.CardTextContainer>{text}</StyledCard.CardTextContainer>
      </Card>
    </StyledCard.CardContainer>
  );
};

export default CardDashboard;
